// extracted by mini-css-extract-plugin
export default {"simpleInput":"input-simple_simpleInput__HK2I4","simpleInputInvalid":"input-simple_simpleInputInvalid__6fFCm"};